/**
 * Scroll to Subscribe section when form is submitted
 *
 * @param {}
 * @return {void}
 */

const $subscriptionMessage = $('.js-subscribe-message');

if ($subscriptionMessage.length !== 0) {
  const $form = $subscriptionMessage.closest('.subscribe');
  // let headerHeight = $('.js-header').outerHeight();
  let headerHeight = 0;
  const formOffset = $form.offset().top - headerHeight;

  $('html, body').animate({
    scrollTop: formOffset
  }, 800);
}
